/* eslint-disable @typescript-eslint/no-explicit-any */

const cfg = (window as any)?.cta_config;

const getUrl = () => {
  if (!cfg) return "#";

  let rawUrl =
    cfg.type == 1 || cfg.type === true ? cfg.custom_link : cfg.post_link;

  if (rawUrl && typeof rawUrl === "object") {
    rawUrl = rawUrl.url;
  }

  if (!rawUrl || rawUrl === "%%cta%%") return "#";

  return rawUrl;
};

export const CTA_LINKS = {
  WELLANAIL_PRODUCT: getUrl(),
  TARGET: cfg?.new_tab == 1 || cfg?.new_tab === true ? "_blank" : "_self",
  REL:
    cfg?.new_tab == 1 || cfg?.new_tab === true
      ? "noopener noreferrer"
      : undefined,
} as const;

export type CTALinkKey = keyof typeof CTA_LINKS;
